import { render, staticRenderFns } from "./NavButton.vue?vue&type=template&id=4600a99c&scoped=true&"
import script from "./NavButton.vue?vue&type=script&lang=js&"
export * from "./NavButton.vue?vue&type=script&lang=js&"
import style0 from "./NavButton.vue?vue&type=style&index=0&id=4600a99c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4600a99c",
  null
  
)

export default component.exports